import { Button, Card, Container, Stack } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useParams, useNavigate } from "react-router-dom";

function MissingLotPage() {

    const { lotNumber } = useParams<{ lotNumber: string; }>();
    const { t } = useTranslation();
    const navigate = useNavigate();

    return (
        <Container>
            <Card bg='light' className='rounded-3 mb-3'>
                <Card.Body>
                    <Stack className='mx-auto my-5'>
                        <h1 className='d-flex justify-content-center'>{t('LotDetails.MissingLot.Missing', {lotNumber: lotNumber})}</h1>
                        <span className='text-muted d-flex justify-content-center'>{t('LotDetails.MissingLot.Explanation')}</span>
                        <div className='d-flex justify-content-center mt-3'>
                            <Button className='mx-1' onClick={() => navigate(-1)}>{t('LotDetails.MissingLot.BackButton')}</Button>
                            <Button className='mx-1' onClick={() => navigate('/lots', { replace: true })}>{t('LotDetails.MissingLot.HomeButton')}</Button>
                        </div>
                    </Stack>
                </Card.Body>
            </Card>
        </Container>
    );
}

export default MissingLotPage